/**
 * Reveal App
 */

jQuery(function($) {

    $('html').removeClass('no-js').addClass('js');

    /**
     * Loading panel
     */

    function appIsLoading() {
        var state = $('html').attr('data-rv-loading');
        return state;
    }

    function closeLoadingPanel() {
        var loadingPanel = $('#rvLoading');

        loadingPanel.velocity({
            translateY: "-100%",
        }, {
            duration: 1000,
            easing: "ease",
            queue: "",
            begin: function() {
                console.log('🚀 revealApp message: Welcome!');
                $('html').attr('data-rv-loading', false);
                $('#rvLoading-dots').removeClass('rvLoading-dots-loading');
            },
            progress: undefined,
            complete: function() {

                // Check for TV Mode
                tvMode();

                // Init skrollr 
                initSkrollr();
            }, 
            display: 'none',
            visibility: 'hidden',
            loop: false,
            delay: 5000,
        });
    }

    if ( appIsLoading() ) {
        console.log('🚀 revealApp message: Loading...');
        closeLoadingPanel();
    }

    /**
	 * Lazyload images/backgrounds
	 * <div data-src="image.jpg"></div> or <img data-src="image.jpg">
	 */

    function loadPanelImages(target) {
        $('#rvPanel-' + target + ' [data-src]').unveil(0, function() {
			$(this).load(function() {
				$(this).css({
					'opacity': 1,
				});
			});
		});
    }

    /**
     * Panel navigation
     */

    // function fadeHomePanelOut() {
    //     $('#rvPanel-home').velocity({
    //         opacity: 0,
    //     }, {
    //         duration: 1000,
    //         easing: "ease",
    //         queue: "",
    //         begin: undefined,
    //         progress: undefined,
    //         complete: undefined,
    //         display: undefined,
    //         visibility: undefined,
    //         loop: false,
    //         delay: 0,
    //     });
    // }

    // function fadeHomePanelIn() {
    //     $('#rvPanel-home').velocity({
    //         opacity: 1,
    //     }, {
    //         duration: 1000,
    //         easing: "ease",
    //         queue: "",
    //         begin: undefined,
    //         progress: undefined,
    //         complete: undefined,
    //         display: undefined,
    //         visibility: undefined,
    //         loop: false,
    //         delay: 1000
    //     });
    // }

    function hideNavBar() {
        var navBar = $('#rvNav');

        navBar.velocity({
            translateX: "-50%",
            opacity: 0,
        }, {
            duration: 1000,
            easing: "ease",
            queue: "",
            begin: undefined,
            progress: undefined,
            complete: undefined,
            display: undefined,
            visibility: undefined,
            loop: false,
            delay: 0,
        });
    }

    function hideLogo() {
        // var navBar = $('#rvBranding');
        // navBar.css({
        //     "transform": "translate3d(0, -100%, 0)",
        // });
    }

    function showLogo() {
        // var navBar = $('#rvBranding');
        // navBar.css({
        //     "transform": "translate3d(0, 0%, 0)",
        // });
    }

    function showNavBar() {
        var navBar = $('#rvNav');

        navBar.velocity({
            translateX: "0%",
            opacity: 1,
        }, {
            duration: 1000,
            easing: "ease",
            queue: "",
            begin: undefined,
            progress: undefined,
            complete: undefined,
            display: undefined,
            visibility: undefined,
            loop: false,
            delay: 0,
        });
    }

    function hideCloseButton() {
        var navBar = $('#rvCloseButton');

        navBar.velocity({
            translateX: "0%",
        }, {
            duration: 1000,
            easing: "ease",
            queue: "",
            begin: undefined,
            progress: undefined,
            complete: undefined,
            display: undefined,
            visibility: undefined,
            loop: false,
            delay: 0,
        });
    }

    function showCloseButton() {
        var navBar = $('#rvCloseButton');

        navBar.velocity({
            translateX: "-100%",
        }, {
            duration: 1000,
            easing: "ease",
            queue: "",
            begin: undefined,
            progress: undefined,
            complete: undefined,
            display: undefined,
            visibility: undefined,
            loop: false,
            delay: 0,
        });
    }

    function openPanel(target) {
        var targetPanel = target;
        var panelToOpen = $('[data-rv-panel=' + targetPanel + ']');
        
        // When the panel opens, we lose the scroll position
        // Stash the pixel value we need to scroll back to
        var distanceScrolledFromTop = $(window).scrollTop();
        $('html').attr('data-scroll-back-to', distanceScrolledFromTop);

        panelToOpen.velocity({
            translateX: "-100%",
        }, {
            duration: 1000,
            easing: "ease",
            queue: "",
            begin: function() {
                console.log('🚀 revealApp message: Opening ' + targetPanel + ' panel');
                hideNavBar();
                // fadeHomePanelOut();
                showCloseButton();
                hideLogo();
                $('html').attr('data-rv-current-panel', targetPanel);
                // setTimeout(function() {
                    $('html').attr('data-rv-panel-open', true);
                // }, 666);
                $('#rvPanel-' + targetPanel).addClass('rvPanel-open');
                loadPanelImages(targetPanel);
            },
            progress: undefined,
            complete: undefined,
            display: 'block',
            visibility: 'visible',
            loop: false,
            delay: 0,
        });
    }

    $('[data-nav-target-panel]').click(function(e) {
        e.preventDefault();
        var target = $(this).attr('data-nav-target-panel');
        openPanel(target);
    });

    function closePanel() {
        var targetPanel = $('html').attr('data-rv-current-panel');
        var panelToClose = $('[data-rv-panel=' + targetPanel + ']');

        // When the panel was opened, we lost our scroll position
        scrollBackToPositionOnMainView();

        panelToClose.velocity({
            translateX: "0%",
        }, {
            duration: 1000,
            easing: "ease",
            queue: "",
            begin: function() {
                console.log('🚀 revealApp message: Going back home from ' + targetPanel + ' panel.');
                $('html').attr('data-rv-current-panel', 'home');
                $('html').attr('data-rv-panel-open', false);
                showLogo();
            },
            progress: undefined,
            complete: undefined,
            display: 'none',
            visibility: 'hidden',
            loop: false,
            delay: 0,
        });
    }

    $('#rvCloseButton').click(function() {
        closePanel();
        showNavBar();
        // fadeHomePanelIn();
        hideCloseButton();
        location.hash.replace('#', '');
    });

    /**
     * Gallery Slider
     */

    function galleryImageLoad() {
        // var currentImage = $('#galleryImage-slider .slick-current').attr('data-gallery-image-src');
        // var nextImage = $('#galleryImage-slider .slick-current').next().attr('data-gallery-image-src');
        // var prevImage = $('#galleryImage-slider .slick-current').prev().attr('data-gallery-image-src');
 
        // $('#galleryImage-slider .slick-current .galleryImage').css('background-image', 'url(' + currentImage + ')');
        // $('#galleryImage-slider .slick-current').next().find('.galleryImage').css('background-image', 'url(' + nextImage + ')');
        // $('#galleryImage-slider .slick-current').prev().find('.galleryImage').css('background-image', 'url(' + prevImage + ')');
    }

    function updateGalleryData() {
        var currentRoomId = $('#galleryImage-slider .slick-current').attr('data-gallery-room-id');
        var currentRoomTitle = $('#galleryImage-slider .slick-current').attr('data-gallery-room-title');

        console.log('🚀 revealApp message: Currently viewing room ' + currentRoomId + ': ' + currentRoomTitle);

        // Update title
        $('#galleryPanel-currentTitle span').text(currentRoomTitle);

        // Update select option
        $('#gallerySelect option').removeAttr('selected');
        $('#gallerySelect option[value="' + currentRoomId + '"]').attr('selected', 'selected');

        // Update content
        $('[data-gallery-content]').removeClass('galleryContent-active');
        $('[data-gallery-content=' + currentRoomId + ']').addClass('galleryContent-active');

        var global_description = $('#galleryImage-slider .slick-current').find('.galleryImage-caption-global');
        var real_description = $('#galleryImage-slider .slick-current').find('.galleryImage-caption-real');
        if (real_description.text()) {
            $('.galleryContent-active').html(real_description.text());
        } else {
            $('.galleryContent-active').html(global_description.text());
        }
    }

    $('[data-nav-target-panel="gallery"]').click(function() {
        // If slider is not initialized
        if ( !$('html').hasClass('slider-init') ) {
            setTimeout(function() {
                initSlick();
            }, 1000);
        }

        setTimeout(function() {
            updateGalleryData();
            galleryImageLoad();
            // $('.slick-slide.slick-current.slick-active').focus();
        }, 1000);
    });

    function initSlick() {
        $('html').addClass('slider-init');
        $('[data-slider="gallery"]').slick({
            accessibility: true,
            autoplay: (isTvMode()) ? true : false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            fade: true,
            draggable: true,
            pauseOnHover: false,
            prevArrow: '<svg class="gallerySlider-arrow gallerySlider-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.23 192.76"><g><rect x="31.91" y="144.69" width="136.18" height="4.15" transform="translate(-124.87 110.08) rotate(-45)" style="fill: #fff"/><rect x="97.92" y="-14.86" width="4.15" height="136.18" transform="translate(-58.73 82.69) rotate(-45)" style="fill: #fff"/></g></svg>',
            nextArrow: '<svg class="gallerySlider-arrow gallerySlider-next"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.23 192.76"><g><rect x="31.91" y="51.16" width="136.18" height="4.15" transform="translate(-58.74 82.69) rotate(-45)" style="fill: #fff"/><rect x="97.92" y="78.67" width="4.15" height="136.18" transform="translate(-124.88 110.09) rotate(-45)" style="fill: #fff"/></g></svg>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        fade: false,
                        draggable: false,
                    }
                }
            ],
        }).on('afterChange', function(event, slick, currentSlide) {
            console.log({currentSlide: currentSlide}); 
            galleryImageLoad();
            updateGalleryData();
            // $('.slick-slide.slick-current.slick-active').focus();
            $('[data-slider="gallery"]').slick('resize');
        });
    }

    $(window).resize(function() {
        $('[data-slider="gallery"]').slick('resize');
    });

    $(window).on('orientationchange', function() {
        $('[data-slider="gallery"]').slick('resize');
    });

    function updateGalleryFromSelectControl(id) {
        var roomId = id;
        var roomTitle = $('#gallerySelect option[value="' + roomId + '"]').attr('data-option-title');
        var slideIndex = $('[data-gallery-room-id=' + roomId + ']:not(.slick-cloned)').attr('data-slick-index');

        console.log('🚀 revealApp message: Navigating to gallery image for ' + roomId + ' ' + roomTitle);

        // Update title
        $('#galleryPanel-currentTitle span').text(roomTitle);

        // Update content
        $('[data-gallery-content]').removeClass('galleryContent-active');
        $('[data-gallery-content=' + roomId + ']').addClass('galleryContent-active');

        // Slide to correct slide
        $('[data-slider="gallery"]').slick('slickGoTo', parseInt(slideIndex));
    }

    $('#gallerySelect').on('change', function() {
        updateGalleryFromSelectControl(this.value);
    });

    /**
     * Home Panel
     */

    // function scrollHideLogo() {
    //     var scrollDistance = 80;
    //     var distanceFromTop = $('#homePanel-scrollArea').scrollTop();

    //     if ( distanceFromTop > scrollDistance ) {
    //         $('[data-rv-loading="false"] #rvBranding').css({
    //             'transform': 'translate3d(0, -100%, 0)',
    //         });
    //     } else {
    //         $('[data-rv-loading="false"] #rvBranding').css({
    //             'transform': 'translate3d(0, 0%, 0)',
    //         });
    //     }
    // }

    // scrollHideLogo();

    // $('#homePanel-scrollArea').scroll(function() {
    //     scrollHideLogo();
    // });

    // function isViewingBottomOfHomePanel() {
    //     var halfTopPanelHeight = ($('#homePanel-top').outerHeight() / 4);
    //     var distanceFromTop = $('#homePanel-scrollArea').scrollTop();

    //     if ( distanceFromTop > halfTopPanelHeight ) {
    //         $('#rvPanel-home').addClass('homePanel-isViewingBottom');
    //     } else {
    //         $('#rvPanel-home').removeClass('homePanel-isViewingBottom');
    //     }
    // }

    // isViewingBottomOfHomePanel();

    // $('#homePanel-scrollArea').scroll(function() {
    //     isViewingBottomOfHomePanel();
    // });

    // function homeContentHeightCrop() {
    //     var contentContainer = $('#homePanel-listingDescription');
    //     var contentHeight = contentContainer.outerHeight();
    //     contentContainer.attr('data-content-height', contentHeight);
    //     contentContainer.css({
    //         'height': '200px',
    //         'overflow': 'hidden',
    //     });
    // }
    //
    // homeContentHeightCrop();
    // $(window).resize(function() { homeContentHeightCrop(); });

    function setContentCropHeight() {
        var contentContainer = $('#homePanel-listingDescription .homePanel-listingDescription-container');
        var contentContainerHeight = contentContainer.outerHeight();
        contentContainer.attr('data-content-height', contentContainerHeight);
        if ( contentContainerHeight > 200 ) {
            $('#homePanel-listingDescription').addClass('listingDescription-isOverflowing');
        } else {
            $('#homePanel-listingDescription').removeClass('listingDescription-isOverflowing');
        }
    }

    setContentCropHeight();

    $(window).resize(function(){
        setContentCropHeight();
    });

    function toggleMoreContent() {
        var contentContainer = $('#homePanel-listingDescription');
        var heightToGrow = $('.homePanel-listingDescription-container').attr('data-content-height');

        if ( contentContainer.hasClass('listingDescription-isCollapsed') ) {
            contentContainer.removeClass('listingDescription-isCollapsed');
            $('.homePanel-listingDescription-container').animate({'height': heightToGrow});
            $('#listingDescription-more > span').text('Read Less');
            $('#listingDescription-more svg').css({'transform': 'rotate(180deg)'});

        } else {
            contentContainer.addClass('listingDescription-isCollapsed');
            $('.homePanel-listingDescription-container').animate({'height': '200px'});
            $('#listingDescription-more > span').text('Read More');
            $('#listingDescription-more svg').css({'transform': 'rotate(0deg)'});
        }
    }

    $('#listingDescription-more').click(function() {
        toggleMoreContent();
    });

    /**
     * Tours
     */

    // Toggle between tours
    $('.tourToggle').click(function() {
        var matterportSrc = $(this).attr('data-matterport-source');
        $('#toursFrame iframe').attr('src', matterportSrc);
    });

    function changeTeamMemberSidePanel(idToChangeTo) {
        $('[data-team-member-sidebar-active="true"]').attr('data-team-member-sidebar-active', false);

        setTimeout(function() {
            $('[data-team-member-sidebar="' + idToChangeTo + '"]').attr('data-team-member-sidebar-active', true);
        }, 10);
    }

    $('[data-team-member-button]').click(function() {
        var idToChangeTo = $(this).attr('data-team-member-button');
        changeTeamMemberSidePanel(idToChangeTo);
    });

    function loadMatterportTour(source) {
        var frame = $('#toursFrame iframe');
        frame.attr('src', source);
    }

    $('[data-nav-target-panel="tours"]').click(function() {
        var frame = $('#toursFrame iframe');
        var source = frame.attr('data-tour-src');


        // If iframe has source
        if ( frame.attr('src') ) {

        } else {
            setTimeout(function() {
                loadMatterportTour(source);
            }, 1000);
        }
    });

    function showLeadCapturePopup(timer) {
        var timer = (timer) ? (timer + 6000) : 14000;
        setTimeout(function() {
            $('#rvPanel-leadCapture').addClass('rv-leadCapture-is-showing');
            $('html').attr('data-rv-lead-capture-open', true);
        }, timer);
    }

    if ( $('html').attr('data-rv-lead-capture') === 'soft' || $('html').attr('data-rv-lead-capture') === 'forced' ) {
        var timer = parseInt($('html').attr('data-tv-lead-capture-timer'));
        showLeadCapturePopup(timer);
    }

    function closeLeadCapturePopup() {
        $('#rvPanel-leadCapture').removeClass('rv-leadCapture-is-showing');
        $('html').attr('data-rv-lead-capture-open', false);
    }

    $('#rv-leadCapture-close').click(function() {
        closeLeadCapturePopup();
    });

    function isTvMode() {
        var url = window.location.href;
        if ( url.indexOf("mode=tv") > -1 || url.indexOf("#tv") > -1 ) {
            return true;
        } else {
            return false;
        }
    }

    function tvModeSetup() {
        if ( isTvMode() ) {
            $('html').attr('data-mode', 'tv');
        }
    }

    tvModeSetup();

    function tvMode() {
        // If URL contains ?mode=tv 
        if ( isTvMode() ) {
            console.log('🚀 revealApp message: Initializing TV mode...');
            initSlick();
            updateGalleryData();
            galleryImageLoad();
            openPanel('gallery');
        }
    }

    // Only works for Gravity Forms ID 2
    // After successful submission on lead capture form, display the X button
    jQuery(document).bind('gform_confirmation_loaded', function(event, formId){
        if ( formId === 2 ) {
            $('#rv-leadCapture-close').css({'display': 'block'});
        }
    });

    function isDemoMode() {
        var url = window.location.href;
        if ( url.indexOf("mode=demo") > -1 || url.indexOf("#demo") > -1 ) {
            return true;
        } else {
            return false;
        }
    }

    // Reload the browser if there is no activity for 90 seconds
    function idleTime() {
        idleTimer = null;
        idleState = false;
        idleWait = 90 * 1000; // 90 seconds

        $('*').bind('mousemove keydown scroll', function() {
            clearTimeout(idleTimer);

            if (idleState === true) { 
                // console.log('User has returned');       
            }

            idleState = false;

            idleTimer = setTimeout(function() {
                // console.log('User is now idle after ' + idleWait + 'ms');       
                location.reload();
            }, idleWait);
        });
        
        $("body").trigger("mousemove");
    }

    if (isDemoMode()) { idleTime(); }

    function initSkrollr() {
        if ( !(/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i).test(navigator.userAgent || navigator.vendor || window.opera) ) {
            var s = skrollr.init({
                forceHeight: false,
                smoothScrolling: true,
                smoothScrollingDuration: 200
            });
        } else {
            $('html').addClass('no-skrollr');
        }
    }

    // When a panel opens, we lose scroll position
    // This fixes that
    function scrollBackToPositionOnMainView() {
        var distanceToScrollDownTo = $('html').attr('data-scroll-back-to');

        $('html, body').animate({ 
            scrollTop: distanceToScrollDownTo 
        }, 10);
    }
});























